/* import __COLOCATED_TEMPLATE__ from './sq-option.hbs'; */
import { and } from '@ember/object/computed';
import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['option'],
  classNameBindings: ['_activeClass', 'isDisabled:option-is-disabled'],
  activeClass: 'option-is-active',
  // Applies customizable `activeClass` if `isActive`` is true
  _activeClass: and('isActive', 'activeClass'),
  isActive: false,
  isDisabled: false,
  click() {
    if (!this.get('isDisabled') && this.optionClickedAction) {
      this.optionClickedAction(this.get('value'), this.get('isActive'));
    }
  }
});